import React, { PropsWithChildren } from 'react';
import { i18n_new_courses_programs_articles } from '@yi/i18n/phrases/i18n_new_courses_programs_articles';

import { utilities } from '~/common';

import { Chip } from './elements';
import { useLocale } from '../LocaleProvider';

const { getDaysSince } = utilities;

interface Props {
  entryDate: { yyyymmdd: string };
}

export const NewChip: React.FC<PropsWithChildren<Props>> = ({ entryDate: { yyyymmdd } }) => {
  const { locale } = useLocale();
  const isNew = getDaysSince(new Date(yyyymmdd)) < 31;
  return isNew ? <Chip>{i18n_new_courses_programs_articles(locale)}</Chip> : null;
};
